import React, { useEffect } from 'react'
import { useState } from 'react';
import DropdownLogin from '../DropdownLogin/DropdownLogin';
import { Button, Dialog, DialogBody, DialogHeader } from '@material-tailwind/react';
import fr from '../../../ASSETS/tourisme/icone/france.png'
import en from '../../../ASSETS/tourisme/icone/united-states-of-america.png'
import { useTranslation } from 'react-i18next';


function Header() {

    const platformEmail = 'info@monbonsejour.com';
    const phoneNumber = '+2250704860005';
    const [data, setData] = useState(() => {
        // getting stored value
        const saved = localStorage.getItem("data");
        const initialValue = saved !== null ? JSON.parse(saved) : null;
        return initialValue;
      });

      const [open, setOpen] = React.useState(false);
      const handleOpen = () => setOpen(!open);
      const [f,setF] =useState(true)
      const [e,setE] = useState(false)

      const {i18n} = useTranslation();
 const initializeLanguage = () => {
    const langue = i18n.language;
  
    if (langue === 'en') {
      setE(true);
      setF(false);
    } else if (langue === 'fr') {
      setE(false);
      setF(true);
    } else {
      // Si une autre langue est sélectionnée
      setE(false);
      setF(false);
    }
  };

  // Appel de l'initialisation au montage du composant
  useEffect(() => {
    initializeLanguage();
  }, []);

  const changerLangue = (lang:any) => {
     
    if(i18n && i18n.changeLanguage){
          i18n.changeLanguage(lang)
         setOpen(false)
         if(lang === 'fr'){
            setE(false)
            setF(true)
         }else{
          setE(true)
          setF(false)
         }
    }
}
  

       const { t } = useTranslation() as { t: (key: string) => string };
      

  return (
      <div style={{ backgroundColor: "#233D4D" }} className='h-12 w-screen flex flex-row space-x-4 justify-end items-center pr-6'>


        {data ? <DropdownLogin/> : null}

          {/* phone */}
          <a href={`https://wa.me/${phoneNumber}`} target="_blank" rel="noopener noreferrer">
          <div className='flex items-center md:space-x-2 s:space-x-0'>
              <div className=''>
                  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="19.185" viewBox="0 0 19.182 19.185">
                      <path id="Tracé_13" data-name="Tracé 13" d="M12.216,12.483,9.735,14.964c-.522.522-2.174-.281-3.689-1.8S3.734,10.007,4.256,9.485L6.737,7,2.614,2.88.557,4.937c-1.514,1.514.327,5.817,4.118,9.6s8.088,5.633,9.6,4.113L16.335,16.6ZM9.617,0V1.918a7.683,7.683,0,0,1,7.674,7.674H19.21A9.592,9.592,0,0,0,9.617,0Z" transform="translate(-0.027)" fill="#fff" />
                  </svg>
              </div>
              <div className='text-white text-xs hover:text-orange-400 cursor-pointer s:w-3 sm:w-5 md:w-full s:invisible md:visible'>
                    +225 07 04 86 00 05
              </div>
          </div>
          </a>

          {/* mail */}
          <a href={`mailto:${platformEmail}`}>
          <div className='flex items-center md:space-x-2 s:space-x-0  '>
              <div className=''>
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="10" viewBox="0 0 25 15">
                      <g id="gmail" transform="translate(-11 -31.3)">
                          <path id="Tracé_7" data-name="Tracé 7" d="M27.577,38.909,36,43.551V34.065ZM11,34.065v9.486l8.423-4.642ZM34.442,31.3H12.558a1.5,1.5,0,0,0-1.519,1.156L23.5,39.613l12.462-7.156A1.511,1.511,0,0,0,34.442,31.3Zm-8.308,8.43L23.923,41a.934.934,0,0,1-.423.117A.722.722,0,0,1,23.077,41L20.865,39.73l-9.808,5.413A1.512,1.512,0,0,0,12.577,46.3H34.462a1.48,1.48,0,0,0,1.519-1.156Z" transform="translate(0)" fill="#fff" />
                      </g>
                  </svg>
              </div>
              <div className='text-white text-xs  sm:w-5 s:w-3 md:w-full  s:invisible md:visible'>
                  info@monbonsejour.com
              </div>
          </div>
          </a>
          
          <div className='E2 flex md:flex-row items-center  md:justify-end  md:space-x-5  s:space-x-0 '>          
                {/* langue */}
                <div className=''>
                 {/* Langage */}
                 <>
                    <Button onClick={handleOpen} variant="gradient">
                      {f && (
                             <svg xmlns="http://www.w3.org/2000/svg" width="34.496" height="19" viewBox="0 0 41.496 24">
                                <g id="langue" transform="translate(-1840 -12)">
                                      <g id="lng" transform="translate(1840.311 12.312)">
                                          <circle id="Ellipse_6" data-name="Ellipse 6" cx="12" cy="12" r="12" transform="translate(-0.311 -0.312)" fill="#f0f0f0"/>
                                          <path id="Tracé_41" data-name="Tracé 41" d="M352.843,27.14a11.965,11.965,0,0,0-7.8-11.217V38.356A11.965,11.965,0,0,0,352.843,27.14Z" transform="translate(-329.155 -15.412)" fill="#d80027"/>
                                          <path id="Tracé_42" data-name="Tracé 42" d="M0,27.14A11.965,11.965,0,0,0,7.8,38.356V15.923A11.965,11.965,0,0,0,0,27.14Z" transform="translate(-0.233 -15.412)" fill="#0052b4"/>
                                      </g>
                                      <g id="down" transform="translate(1868.674 -112.346)">
                                          <g id="Groupe_6" data-name="Groupe 6" transform="translate(0 136.346)">
                                              <path id="Tracé_43" data-name="Tracé 43" d="M6.9,143.25a.687.687,0,0,1-.969,0L.2,137.515a.685.685,0,0,1,.969-.969L6.9,142.281A.687.687,0,0,1,6.9,143.25Z" transform="translate(0 -136.346)" fill="#fff" fillRule="evenodd"/>
                                              <path id="Tracé_44" data-name="Tracé 44" d="M273.043,143.4a.687.687,0,0,1,0-.969l5.735-5.735a.685.685,0,1,1,.969.969l-5.735,5.735A.687.687,0,0,1,273.043,143.4Z" transform="translate(-267.125 -136.494)" fill="#fff" fillRule="evenodd"/>
                                          </g>
                                      </g>
                                </g> 
                          </svg>
                      )}

                      {e && (
                              
                        <div className="flex items-center">
                            <img src={en} alt="anglais" className='w-5' />
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="34.496"
                              height="19"
                              viewBox="0 0 41.496 24"
                            >
                              <g id="langue" transform="translate(-1865 -12)">
                                <g id="down" transform="translate(1868.674 -112.346)">
                                  <g id="Groupe_6" data-name="Groupe 6" transform="translate(0 136.346)">
                                    <path
                                      id="Tracé_43"
                                      data-name="Tracé 43"
                                      d="M6.9,143.25a.687.687,0,0,1-.969,0L.2,137.515a.685.685,0,0,1,.969-.969L6.9,142.281A.687.687,0,0,1,6.9,143.25Z"
                                      transform="translate(0 -136.346)"
                                      fill="#fff"
                                      fillRule="evenodd"
                                    />
                                    <path
                                      id="Tracé_44"
                                      data-name="Tracé 44"
                                      d="M273.043,143.4a.687.687,0,0,1,0-.969l5.735-5.735a.685.685,0,1,1,.969.969l-5.735,5.735A.687.687,0,0,1,273.043,143.4Z"
                                      transform="translate(-267.125 -136.494)"
                                      fill="#fff"
                                      fillRule="evenodd"
                                    />
                                  </g>
                                </g>
                              </g>
                            </svg>
                        </div>
                      )}


                    </Button>
                    <Dialog open={open} handler={handleOpen} className='w-[350px] h-[250px]' >
                        <DialogHeader style={{fontSize:'20px'}}>{t('Veuillez selectionner une langue')}</DialogHeader>
                        <DialogBody>

                        <div  onClick={()=>changerLangue('fr')} className='flex flex-row items-center space-x-3 hover:bg-slate-50 p-4 rounded-md cursor-pointer'>
                            <img src={fr} alt='french' className='w-10'/>
                            <div className='text-lg font-medium'>Français</div>
                        </div>

                        <div  onClick={()=>changerLangue('en')} className='flex flex-row items-center space-x-3 hover:bg-slate-50 p-4 rounded-md cursor-pointer'>
                            <img src={en} alt='anglais' className='w-10'/>
                            <div className='text-lg font-medium'>Anglais</div>
                        </div>
                        </DialogBody>
                    </Dialog>
                    </>
                </div>
          </div>

    </div>
  )
}

export default Header